import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    maxWidthStyle:{
    minWidth:"100%",
    width:"100%"
  },
  table: {
    minWidth: 650,
    height: "50%"
  },
  aktiverMesspunktColumn: {
    borderRight: `1px solid ${
      theme.palette.type === 'light' ? '#f0f0f0' : '#303030'
    }`,
  },
  columnMinWith: {
    minWidth: "5vw"
  },
  columnComment: {
    minWidth: "7vw",
    maxWidth: "25vw",
    whiteSpace: "pre-wrap",
  },
  datePicker: {
    minWidth: "100%",
    marginTop: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
      paddingTop: "5px",
    },
  },
  numberField: {
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none"
    }
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  justifyEnd: {
    justifyContent:'flex-end',
  },
  justifyText: {
    textAlign: 'justify',
  },
  justifyItems:{
    alignItems:'center',
  },
}), {index: 1});
